import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { TaxPayerType } from './types'
import {Button} from "@/components/ui/button.tsx";
import {ArrowLeft} from "lucide-react";

interface NewProps {
  tax_payer: TaxPayerType
  categories: { id: string; name: string }[]
  areas: { id: string; name: string }[]
}

export default function New({ tax_payer, categories, areas }: NewProps) {
  return (
    <>
      <Head title="New tax payer" />
    <div className={"gap-6 p-8 flex flex-col"}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link href="/taxpayers">
            <Button variant="outline" size="icon">
              <ArrowLeft className="h-4 w-4" />
            </Button>
          </Link>
          <div>
            <h1 className="text-3xl font-bold text-foreground">Add New Taxpayer</h1>
            <p className="text-sm text-muted-foreground">Register a new taxpayer in the system</p>
          </div>
        </div>
      </div>

        <Form
          tax_payer={tax_payer}
          categories={categories}
          areas={areas}
          method="post"
          action="/tax_payers"
          submitText="Create Tax payer"
        />


      </div>
    </>
  )
}
